import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { MfaSecret, MfaSecretCreate, MfaSecretFilter } from '../data/mfaSecret';

export function createMfaSecretService(client: AxiosInstance) {
  return createCrudService<MfaSecret, MfaSecretCreate, MfaSecretFilter>(
    client,
    '/identity/MfaSecret',
    'id',
  );
}

export type MfaSecretService = CrudService<MfaSecret, MfaSecretCreate, MfaSecretFilter>;
